import { connect } from 'react-redux'
import get from 'lodash/get'

import {
  openIntelligenceDateControls as onOpenIntelligenceDateControls,
  closeIntelligenceDateControls as onCloseIntelligenceDateControls
} from './../../actions/intelligenceDateControlsActions'

const mapStateToProps = (state) => ({
  isIntelligenceDateControlsOpen: get(state, ['intelligenceDateControls', 'isDateControlsOpen'], true)
})

const mapDispatchToProps = {
  onOpenIntelligenceDateControls,
  onCloseIntelligenceDateControls
}

const withIntelligenceDateControls = Component => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withIntelligenceDateControls }